export default __webpack_public_path__ + "img/a14fcc983fa4a77d677c7c845a2191f6.svg";